import { store } from '~/Store'
import { getDisabledRelations, getDisabledTypes } from 'Services/WeaverUtils'
import { updateRelationFilters, updateTypeFilters } from 'Actions/graphFilter'
import { getRelationkeyLabel } from 'Services/WeaverUtils'

export const shouldFilterRelations = (selects) => ('*' in selects || _.isEmpty(selects))

const createDisabledRelationObject = (disabledRelation) => {
  return {
    key: disabledRelation,
    enabled: false,
    label: getRelationkeyLabel(disabledRelation)
  }
}

const createDisabledTypeObject = (disabledType) => ({
  id: disabledType,
  enabled: false,
  label: disabledType
})

const prepareFilters = (disabledItems, createObject) => {
  if (_.isEmpty(disabledItems)) {
    return []
  }
  const disabledCollection = disabledItems.map(createObject)
  const key = disabledItems[0].key ? 'key' : 'id';
  return _.keyBy(disabledCollection, key);
}

const dispatchFilterUpdates = (disabledRelations, disabledTypes) => {
  const relationFilters = prepareFilters(disabledRelations, createDisabledRelationObject)
  const typeFilters = prepareFilters(disabledTypes, createDisabledTypeObject)

  store.dispatch(updateRelationFilters(relationFilters))
  store.dispatch(updateTypeFilters(typeFilters))
}

const preApplyFilters = () => {
  const disabledRelations = getDisabledRelations() || []
  const disabledTypes = getDisabledTypes() || []

  dispatchFilterUpdates(disabledRelations, disabledTypes)
}

export {
  preApplyFilters
}
